import { useQuery } from '@tanstack/react-query';
import inspectionApi from '../services/inspection.api';
import { inspectionKeys } from './useVehicleInspections';

const useDashboardStats = () =>
  useQuery({
    queryKey: inspectionKeys.stats(),
    queryFn: inspectionApi.getStats,
  });

export default useDashboardStats;
